import { gql } from '@apollo/client';

/**
 * GraphQL query for getting community prompt details
 */
export const GET_COMMUNITY_PROMPT_DETAILS = gql`
  query GetCommunityPromptDetails($communityId: ID!, $input: GetCommunityPromptDetailsInput!) {
    communityPromptDetails(communityId: $communityId, input: $input) {
      prompt
    }
  }
`;
